import React from 'react';

const SharedEleHistory = () => {
  return <div>Shared elements History</div>;
};

export default SharedEleHistory;
